import { ElementType, ReactNode } from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import {
  color,
  space,
  SpaceProps,
  ColorProps,
  typography,
  TypographyProps,
  LayoutProps,
  layout,
} from "styled-system";

interface CellProps
  extends SpaceProps,
    ColorProps,
    TypographyProps,
    LayoutProps {
  /**
   * children elements
   */
  children: ReactNode;
  /**
   *The element's unique identifier
   */
  id?: string;
  /**
   * sets the right border for the current cell
   */
  verticalDividerAfter?: boolean;
  /**
   * as prop is instructing the component to render its wrapper element as some other element <br/>
   * <b>default element: td</b>
   */
  as?: ElementType;
}

const Cell = styled.td<CellProps>`
  position: relative;
  padding: inherit;
  margin: inherit;
  border-bottom: inherit;
  word-wrap: break-word;
  box-sizing: border-box;
  color: inherit;
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  max-width: min-content;

  &:focus {
    outline: none;
  }
  ${(props) =>
    css({
      borderRight: props.verticalDividerAfter ? "1px solid" : "none",
      borderRightColor: "table-border-color",
    })}
  ${space}
  ${color}
  ${typography}
  ${layout}
`;

const TableCell = ({
  children,
  verticalDividerAfter = false,
  color,
  ...props
}: CellProps) => (
  <Cell
    tabIndex={0}
    verticalDividerAfter={verticalDividerAfter}
    color={color as string}
    {...props}
  >
    {children}
  </Cell>
);

export default TableCell;
